import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types.ts';

export const setEntryFieldField: YJSChangeHandler<
  DatabaseChangeType.SET_ENTRY_FIELD_FIELD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.entryFieldField = change.entryFieldField;
  });
};
